import React from 'react';
import { Box, Typography, Container, Grid, Link as MuiLink, TextField, Button, IconButton, Stack, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0a1929', // Very Dark Blue
        color: 'white',
        pt: 10,
        pb: 4,
        mt: 'auto',
        borderTop: '4px solid #0d47a1'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          {/* Column 1: Company Info */}
          <Grid item xs={12} md={4}>
            {/* Logo */}
            <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', mb: 3 }}>
              <Box sx={{ bgcolor: 'white', p: 1, borderRadius: 1, mr: 2, display: 'flex', alignItems: 'center' }}>
                <Box component="img" src="/images/logo.png" alt="Ayda Logo" sx={{ height: { xs: 30, md: 40 } }} />
              </Box>
              <Typography variant="h5" component="div" sx={{ fontWeight: '900', letterSpacing: 1, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
                AYDA INDUSTRIES
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ opacity: 0.7, lineHeight: 1.8, mb: 3 }}>
              Pioneering the future of precision manufacturing. We deliver high-tolerance components for the world's most demanding industries, from Aerospace to Medical devices.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}><LinkedInIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}><TwitterIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}><FacebookIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}><InstagramIcon /></IconButton>
            </Stack>
          </Grid>

          {/* Column 2: Quick Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
              Company
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              <MuiLink component={Link} to="/" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Home</MuiLink>
              <MuiLink component={Link} to="/about" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>About Us</MuiLink>
              <MuiLink component={Link} to="/quality" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Quality Policy</MuiLink>
              <MuiLink component={Link} to="/careers" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Careers</MuiLink>
            </Box>
          </Grid>

          {/* Column 3: Services */}
          <Grid item xs={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
              Capabilities
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              <MuiLink component={Link} to="/services" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>CNC Machining</MuiLink>
              <MuiLink component={Link} to="/services" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Turned Parts</MuiLink>
              <MuiLink component={Link} to="/services" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Prototyping</MuiLink>
              <MuiLink component={Link} to="/services" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Surface Finishing</MuiLink>
            </Box>
          </Grid>

          {/* Column 4: Newsletter */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
              Stay Connected
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
              Subscribe to our newsletter for industry insights and company updates.
            </Typography>
            <Box component="form" noValidate autoComplete="off" sx={{ display: 'flex', gap: 1 }}>
              <TextField
                variant="outlined"
                placeholder="Your email address"
                size="small"
                fullWidth
                sx={{ bgcolor: 'rgba(255,255,255,0.1)', input: { color: 'white' }, borderRadius: 1 }}
              />
              <Button variant="contained" color="primary">Subscribe</Button>
            </Box>

            <Box sx={{ mt: 4 }}>
              <Box display="flex" alignItems="center" mb={1} sx={{ opacity: 0.8 }}>
                <LocationOnIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant="body2">Coimbatore, Tamil Nadu, India</Typography>
              </Box>
              <Box display="flex" alignItems="center" mb={1} sx={{ opacity: 0.8 }}>
                <PhoneIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant="body2">+91 9080 671 664</Typography>
              </Box>
              <Box display="flex" alignItems="center" sx={{ opacity: 0.8 }}>
                <EmailIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant="body2">business@aydaindia.com</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 6, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="body2" sx={{ opacity: 0.5 }}>
              © {new Date().getFullYear()} AYDA INDUSTRIES PVT LTD. All Rights Reserved.
            </Typography>
          </Grid>
          <Grid item>
            <Stack direction="row" spacing={3}>
              <MuiLink href="#" color="inherit" underline="hover" sx={{ opacity: 0.5, fontSize: '0.85rem' }}>Privacy Policy</MuiLink>
              <MuiLink href="#" color="inherit" underline="hover" sx={{ opacity: 0.5, fontSize: '0.85rem' }}>Terms of Service</MuiLink>
              <MuiLink href="#" color="inherit" underline="hover" sx={{ opacity: 0.5, fontSize: '0.85rem' }}>Sitemap</MuiLink>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
